<template>
  <div id="Results">
    <table>
      <tr style="background: #ddd;">
        <td class='tabOpis' style="text-align:right;padding-right: 10px; font-weight:bold">{{$t("message.clusters")}}</td>
        <td></td>
        <td style="font-weight:bold">1</td>
        <td style="font-weight:bold">2</td>
        <td style="font-weight:bold">3</td>
        <td style="font-weight:bold">4</td>
        <td style="font-weight:bold">5</td>
        <td style="font-weight:bold">6</td>
      </tr>
      <tr>
        <td class='tabOpis'>{{$t('message.requiredBattery')}}</td>
        <td>[Ah]</td>
        <td>{{(outputs.resultDevices.c1) ? Number(outputs.resultDevices.c1.required) : 0}}</td>
        <td>{{(outputs.resultDevices.c2) ? Number(outputs.resultDevices.c2.required) : 0}}</td>
        <td>{{(outputs.resultDevices.c3) ? Number(outputs.resultDevices.c3.required) : 0}}</td>
        <td>{{(outputs.resultDevices.c4) ? Number(outputs.resultDevices.c4.required) : 0}}</td>
        <td>{{(outputs.resultDevices.c5) ? Number(outputs.resultDevices.c5.required) : 0}}</td>
        <td>{{(outputs.resultDevices.c6) ? Number(outputs.resultDevices.c6.required) : 0}}</td>
      </tr>
      <tr>
        <td class='tabOpis'>{{$t('message.maxBattery')}}</td>
        <td>[A]</td>
        <td>{{(outputs.resultDevices.c1) ? Number(outputs.resultDevices.c1.maxBC) : 0}}</td>
        <td>{{(outputs.resultDevices.c2) ? Number(outputs.resultDevices.c2.maxBC) : 0}}</td>
        <td>{{(outputs.resultDevices.c3) ? Number(outputs.resultDevices.c3.maxBC) : 0}}</td>
        <td>{{(outputs.resultDevices.c4) ? Number(outputs.resultDevices.c4.maxBC) : 0}}</td>
        <td>{{(outputs.resultDevices.c5) ? Number(outputs.resultDevices.c5.maxBC) : 0}}</td>
        <td>{{(outputs.resultDevices.c6) ? Number(outputs.resultDevices.c6.maxBC) : 0}}</td>
      </tr>
      <tr>
        <td class='tabOpis'>{{$t('message.mainsCurrent230')}}</td>
        <td>[A]</td>
        <td>{{(outputs.resultDevices.c1) ? Number(outputs.resultDevices.c1.mc230) : 0}}</td>
        <td>{{(outputs.resultDevices.c2) ? Number(outputs.resultDevices.c2.mc230) : 0}}</td>
        <td>{{(outputs.resultDevices.c3) ? Number(outputs.resultDevices.c3.mc230) : 0}}</td>
        <td>{{(outputs.resultDevices.c4) ? Number(outputs.resultDevices.c4.mc230) : 0}}</td>
        <td>{{(outputs.resultDevices.c5) ? Number(outputs.resultDevices.c5.mc230) : 0}}</td>
        <td>{{(outputs.resultDevices.c6) ? Number(outputs.resultDevices.c6.mc230) : 0}}</td>
      </tr>
      <tr>
        <td class='tabOpis'>{{$t('message.mainsCurrent115')}}</td>
        <td>[A]</td>
        <td>{{(outputs.resultDevices.c1) ? Number(outputs.resultDevices.c1.mc115) : 0}}</td>
        <td>{{(outputs.resultDevices.c2) ? Number(outputs.resultDevices.c2.mc115) : 0}}</td>
        <td>{{(outputs.resultDevices.c3) ? Number(outputs.resultDevices.c3.mc115) : 0}}</td>
        <td>{{(outputs.resultDevices.c4) ? Number(outputs.resultDevices.c4.mc115) : 0}}</td>
        <td>{{(outputs.resultDevices.c5) ? Number(outputs.resultDevices.c5.mc115) : 0}}</td>
        <td>{{(outputs.resultDevices.c6) ? Number(outputs.resultDevices.c6.mc115) : 0}}</td>
      </tr>
      <tr>
        <td class='tabOpis'>{{$t('message.myRequiredBattery')}}</td>
        <td>[Ah]</td>
        <td>{{(outputs.akumulators.c1) ? Number(outputs.akumulators.c1.pojemnosc) : 0}}</td>
        <td>{{(outputs.akumulators.c2) ? Number(outputs.akumulators.c2.pojemnosc) : 0}}</td>
        <td>{{(outputs.akumulators.c3) ? Number(outputs.akumulators.c3.pojemnosc) : 0}}</td>
        <td>{{(outputs.akumulators.c4) ? Number(outputs.akumulators.c4.pojemnosc) : 0}}</td>
        <td>{{(outputs.akumulators.c5) ? Number(outputs.akumulators.c5.pojemnosc) : 0}}</td>
        <td>{{(outputs.akumulators.c6) ? Number(outputs.akumulators.c6.pojemnosc) : 0}}</td>
      </tr>
    </table>

    <br>

    <table>
      <tr style="background: #ddd;">
        <td class='tabOpis' style="text-align:right;padding-right: 10px; font-weight:bold"></td>
        <td></td>
        <td style="font-weight:bold">{{$t("message.active")}} ({{$t("message.idle")}})</td>
        <td style="font-weight:bold">{{$t("message.active")}}</td>
        <td style="font-weight:bold">{{$t("message.active")}} ({{$t("message.full")}})</td>
      </tr>
      <tr>
        <td class='tabOpis'>{{$t('message.totalLossPower')}}</td>
        <td>[W]</td>
        <td>{{(outputs.resultLoss.powerIdle) ? Number(outputs.resultLoss.powerIdle).toFixed(0) : 0}}</td>
        <td>{{(outputs.resultLoss.powerActive) ? Number(outputs.resultLoss.powerActive).toFixed(0) : 0}}</td>
        <td>{{(outputs.resultLoss.powerActiveFull) ? Number(outputs.resultLoss.powerActiveFull).toFixed(0) : 0}}</td>
      </tr>
      <tr>
        <td class='tabOpis'>{{$t('message.totalLossHeat')}}</td>
        <td>[BTU/h]</td>
        <td>{{(outputs.resultLoss.heatIdle) ? Number(outputs.resultLoss.heatIdle).toFixed(0) : 0}}</td>
        <td>{{(outputs.resultLoss.heatActive) ? Number(outputs.resultLoss.heatActive).toFixed(0) : 0}}</td>
        <td>{{(outputs.resultLoss.heatActiveFull) ? Number(outputs.resultLoss.heatActiveFull).toFixed(0) : 0}}</td>
      </tr>
      <tr>
        <td class='tabOpis'>{{$t('message.totalLossKcal')}}</td>
        <td>[kcal/h]</td>
        <td>{{(outputs.resultLoss.kcalIdle) ? Number(outputs.resultLoss.kcalIdle).toFixed(0) : 0}}</td>
        <td>{{(outputs.resultLoss.kcalActive) ? Number(outputs.resultLoss.kcalActive).toFixed(0) : 0}}</td>
        <td>{{(outputs.resultLoss.kcalActiveFull) ? Number(outputs.resultLoss.kcalActiveFull).toFixed(0) : 0}}</td>
      </tr>
    </table>

    <br>

    <table>
      <tr>
        <td class='tabOpis' style="width: 220px">{{$t('message.przylacze_zasilania')}}</td>
        <td style="width: 92px;">[V]</td>
        <td colspan="2">{{(inputs['przylacze_zasilania'].value > 0) ? (inputs['przylacze_zasilania'].value > 2 ? $t('message.faza3') : $t('message.faza1')) : ''}}</td>
      </tr>
    </table>

    <br>

    <table id="restResults">
      <tr style="text-align:left">
        <td>{{$t("message.height_u")}}</td>
        <td>[U]</td>
        <td>{{(outputs.szafa.attributes.wysokosc) ? outputs.szafa.attributes.wysokosc : 0}}</td>
      </tr>
      <tr>
        <td>{{$t("message.height_mm")}}</td>
        <td>[mm]</td>
        <td>{{(outputs.szafa.attributes.mm) ? outputs.szafa.attributes.mm : 0}}</td>
      </tr>
      <tr>
        <td>{{$t("message.dimensions_rack")}}</td>
        <td>[mm]</td>
        <td>{{(outputs.szafa.attributes.szerokosc) ? outputs.szafa.attributes.szerokosc + 'x' + outputs.szafa.attributes.glebokosc : 0}}</td>
      </tr>
      <tr>
        <td>{{$t("message.weight_rack")}}</td>
        <td>[kg]</td>
        <td>{{(outputs.szafa.attributes.waga) ? Number(outputs.szafa.attributes.waga).toFixed(2) : 0}}</td>
      </tr>
      <tr>
        <td>{{$t("message.weight_battery")}}</td>
        <td>[kg]</td>
        <td>{{(outputs.waga.akumulatory) ? Number(outputs.waga.akumulatory).toFixed(2) : 0}}</td>
      </tr>
      <tr>
        <td>{{$t("message.weight_system")}}</td>
        <td>[kg]</td>
        <td>{{(outputs.waga.total) ? outputs.waga.total : 0}}</td>
      </tr>
    </table>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Results',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('app', ['outputs', 'inputs']),
    checkCluster1 () {
      if (this.outputs.resultDevices.c1) {
        return !!((this.outputs.resultDevices.c1.maxBC !== 0 && this.outputs.resultDevices.c1.mc230 !== 0 && this.outputs.resultDevices.c1.mc115 !== 0))
      } else {
        return false
      }
    },
    checkCluster2 () {
      if (this.outputs.resultDevices.c2) {
        return !!((this.outputs.resultDevices.c2.maxBC !== 0 && this.outputs.resultDevices.c2.mc230 !== 0 && this.outputs.resultDevices.c2.mc115 !== 0))
      } else {
        return false
      }
    },
    checkCluster3 () {
      if (this.outputs.resultDevices.c3) {
        return !!((this.outputs.resultDevices.c3.maxBC !== 0 && this.outputs.resultDevices.c3.mc230 !== 0 && this.outputs.resultDevices.c3.mc115 !== 0))
      } else {
        return false
      }
    },
    checkCluster4 () {
      if (this.outputs.resultDevices.c4) {
        return !!((this.outputs.resultDevices.c4.maxBC !== 0 && this.outputs.resultDevices.c4.mc230 !== 0 && this.outputs.resultDevices.c4.mc115 !== 0))
      } else {
        return false
      }
    },
    checkCluster5 () {
      if (this.outputs.resultDevices.c5) {
        return !!((this.outputs.resultDevices.c5.maxBC !== 0 && this.outputs.resultDevices.c5.mc230 !== 0 && this.outputs.resultDevices.c5.mc115 !== 0))
      } else {
        return false
      }
    },
    checkCluster6 () {
      if (this.outputs.resultDevices.c6) {
        return !!((this.outputs.resultDevices.c6.maxBC !== 0 && this.outputs.resultDevices.c6.mc230 !== 0 && this.outputs.resultDevices.c6.mc115 !== 0))
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
  text-align: left;
font-size: 14px;
}
table tr td {
white-space: break-spaces;
}
table tr:nth-child(even) {background: #F7F7F7}
table tr:nth-child(odd) {background: #FFF}

table tr td {
  text-align: center;
  width: 50px;
  border: 1px solid rgb(209, 208, 208);
}
.tabOpis {
  width:320px;
  text-align: left;
padding: 4px;
}
#Results {
  max-width: 100%;
  /* margin: 26px auto; */
}
#restResults tr td {
  text-align: left;
}
#restResults tr td:nth-child(2) {
  text-align: center;
}
#restResults tr td:nth-child(3) {
  text-align: center;
}

h1 {
  font-family: 'Amarante', Tahoma, sans-serif;
  font-weight: bold;
  font-size: 3.6em;
  line-height: 1.7em;
  margin-bottom: 10px;
  text-align: center;
}

/** page structure **/
#wrapper {
  display: block;
  width: 850px;
  background: #fff;
  margin: 0 auto;
  padding: 10px 17px;
  /* -webkit-box-shadow: 2px 2px 3px -1px rgba(0,0,0,0.35); */
}

#keywords {
  /* margin: 0 auto; */
  font-size: 1.0em;
  margin-bottom: 15px;
  width: 100%;
}

#keywords thead {
  cursor: pointer;
  /* background: #f4f4f4; */
  background: #ddd;
}
#keywords thead tr th {
  font-weight: bold;
  padding: 8px 0px;
  width: 60px;text-align: center;
}
#keywords thead tr th span {
  background-repeat: no-repeat;
  background-position: 100% 100%;
}

#keywords thead tr th.headerSortUp, #keywords thead tr th.headerSortDown {
  background: #f4f4f4;
}

#keywords thead tr th.headerSortUp span {
  background-image: url('https://i.imgur.com/SP99ZPJ.png');
}
#keywords thead tr th.headerSortDown span {
  background-image: url('https://i.imgur.com/RkA9MBo.png');
}

#keywords tbody tr {
  color: #555;
  border-bottom: 1px solid #999;
}
#keywords tbody tr td {
  padding: 5px 10px;
  font-size: 14px;
  text-align: center;
}
#keywords tbody tr td.lalign {
  text-align: left;
}
.titleTable {
  padding: 6px 0px;
  font-size: 15px;
}
.titleTable p{
  /* text-indent: 50px; */
  /* text-align: justify; */
  /* letter-spacing: 1px; */
  height: 42px;
  margin-bottom: 0px;
}
.shortTitle {
  height: 24px;
}
.rowResult {
  background: #f4f4f4;
}
.tdGrupa {
  width:150px; text-align:left;padding-left: 10px;
}
.valCluster {
  background: #f4f4f4; padding:6px; font-weight:bold; border-bottom:2px solid #999
}
.col {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Results.vue